import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-06bd896a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "appDetailPage" }
const _hoisted_2 = { style: { display: 'flex', alignItems: 'center' } }

import { computed, ref, watchEffect } from "vue";
import API from "@/api";
import { getAppVoByIdUsingGet } from "@/api/appController";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import { useLoginUserStore } from "@/store/userStore";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import ShareModal from "@/components/ShareModal.vue";

interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDetailPage',
  props: {
    id: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

const data = ref<API.AppVO>({});

// 分享模态框的引用
const shareModalRef = ref();
//  分享链接 无论是前端还是线上 这段代码都不需要改
const shareLink = `${window.location.protocol}//${window.location.host}/app/detail/${props.id}`;

// 分享弹窗
const doShare = (e: Event) => {
  if (shareModalRef.value) {
    shareModalRef.value.openModal();
  }
  e.stopPropagation();
};

// 获取登录用户
const loginUserStore = useLoginUserStore();
let loginUserId = loginUserStore.loginUser?.id;
// 是否为本人创建
const isMy = computed(() => {
  return loginUserId && loginUserId === data.value.userId;
});

/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const res = await getAppVoByIdUsingGet({
    id: props.id as any,
  });
  if (res.data.code === 0) {
    data.value = res.data.data as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              class: "content-wrapper"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString(data.value.appName), 1),
                _createElementVNode("p", null, _toDisplayString(data.value.appDesc), 1),
                _createElementVNode("p", null, "应用类型：" + _toDisplayString(_unref(APP_TYPE_MAP)[data.value.appType]), 1),
                _createElementVNode("p", null, "评分策略：" + _toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[data.value.scoringStrategy]), 1),
                _createElementVNode("p", null, [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" 作者： "),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_a_avatar, {
                          size: 24,
                          "image-url": data.value.user?.userAvatar ?? 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fsafe-img.xhscdn.com%2Fbw%2F24381cb9-686c-4cbc-8941-64a6696fa8f8%3FimageView2%2F2%2Fw%2F1080%2Fformat%2Fjpg&refer=http%3A%2F%2Fsafe-img.xhscdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1722749499&t=e58c1a05fb41f6a92225ebc2a6e4f1d5',
                          style: { marginRight: '8px' }
                        }, null, 8, ["image-url"]),
                        _createVNode(_component_a_typography_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.value.user?.userName ?? "无名之辈"), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, " 创建时间：" + _toDisplayString(_unref(dayjs)(data.value.createTime).format("YYYY-MM-DD HH:mm:ss")), 1),
                _createVNode(_component_a_space, { size: "medium" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      href: `/answer/do/${_ctx.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("开始答题")
                      ]),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_a_button, { onClick: doShare }, {
                      default: _withCtx(() => [
                        _createTextVNode("分享应用")
                      ]),
                      _: 1
                    }),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          href: `/add/question/${_ctx.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("设置题目 ")
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          href: `/add/scoring_result/${_ctx.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("设置评分 ")
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          href: `/add/app/${_ctx.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("修改应用")
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { flex: "320px" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  width: "100%",
                  src: data.value.appIcon
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ShareModal, {
      link: shareLink,
      title: "应用分享",
      ref_key: "shareModalRef",
      ref: shareModalRef
    }, null, 512)
  ]))
}
}

})